import React from "react";
// import PropTypes from 'prop-types';
import "./Input.css";

const Input = props => {
   let inputElement = "";
   let invalidInputMsg = null;

   const inputClasses = ["input-element"];

   if (!props.isValid && props.isTouched) {
      inputClasses.push("input-element-invalid");
      invalidInputMsg = (
         <span
            className="invalid-msg"
            automationid={`SalesLead_Span_${props.automationidattr}InvalidMsg_0`}
         >
            {props.validations.invalidMessage}
         </span>
      );
   }

   switch (props.type) {
      case "textArea":
         inputElement = (
            <textarea
               className={inputClasses.join(" ")}
               {...props.config}
               value={props.value}
               style={props.style}
               onChange={event => props.changed(event, props.inputIdentifier)}
            ></textarea>
         );
         break;
      case "select":
         return (
            <React.Fragment>

            </React.Fragment>
         );
      case "radio":
         inputElement = props.config.options.map(option => (
            <div key={option.value} className="radio-input-container" >
               <label >
                  <input
                     type="radio"
                     value={option.value}
                     name={props.name}
                     style={props.style}
                     checked={option.value === props.value}
                     onChange={event =>
                        props.changed(event, props.inputIdentifier)
                     }
                  />
                  {option.displayName}
               </label>
            </div>
         ));
         break;
      case "checkbox":
         return (
            <div className="checkbox-input-container" >
               <input
                  type="checkbox"
                  name={props.name}
                  id={props.name}
                  style={props.style}
                  onChange={event =>
                     props.changed(event, props.inputIdentifier)
                  }
               />
               <label className="checkbox-label" htmlFor={props.name} >
                  {props.name}
               </label>
            </div>
         );
      case "input":
      default:
         inputElement = (
            <input
               value={props.value}
               style={props.style}
               onChange={event => props.changed(event, props.inputIdentifier)}
               className={inputClasses.join(" ")}
               {...props.config}
               automationid={`SalesLead_Input_${props.automationidattr}Input_0`}
            />
         );
         break;
   }
   return (
      <div className="input-container" >
         {inputElement}
         <label
            className="input-label"
            automationid={`SalesLead_Label_${props.automationidattr}InputLabel_0`}
         >
            {props.name}
         </label>
         {invalidInputMsg}
      </div>
   );
};

// Input.propTypes = {
//    name: PropTypes.string,
//    type: PropTypes.string,
//    value: PropTypes.string,
//    isValid: PropTypes.bool,
//    isTouched: PropTypes.bool,
//    validations: PropTypes.object,
//    config: PropTypes.object,
// };

export default Input;
